export const PROJECT_INIT = 'PROJECT_INIT';
export const PROJECT_FAIL = 'PROJECT_FAIL';
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const SELECT_PROJECT = 'SELECT_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const DELETE_GALLERY = 'DELETE_GALLERY';
